import EventEmitter from "eventemitter3";

export const modalPopupEmitter = new EventEmitter();

export const onEmitModalPopup = (modal: string) => {
  modalPopupEmitter.emit("open-modal", modal);
};
